// FetchDoctorById.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchDoctorById } from '../Services/apiService';

const DoctorById = () => {
  const { id } = useParams(); // Use useParams to get the id
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getDoctor = async () => {
      try {
        const doctorData = await fetchDoctorById(id);
        setDoctor(doctorData);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    getDoctor();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return (
      <div>
        Error:
        {error}
      </div>
    );
  }

  return (
    <div>
      {doctor ? (
        <div>
          <h1>{doctor.name}</h1>
          <h1>{doctor.bangla_name}</h1>
          <p>{doctor.id}</p>
        </div>
      ) : (
        <div>No doctor found.</div>
      )}
    </div>
  );
};

export default DoctorById;
